      
      <div *ngIf="showSwiperContainer" class="swiper-container swiper-container--dashboard swiper-dashboard mt-4">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <span class=" d-block mb-3 subtitle-1--weight-regular">Active Campaigns</span>
            <div class="list-group list-group-light mr-auto period-buttons">
              <button type="button" (click)="getCampaignsMTD()" [ngClass]="activeBtn=='mtd'?'active':''" class="list-group-item list-group-item-action  px-3">
                MTD
              </button>
              <button type="button" (click)="getCampaignsYTD()" [ngClass]="activeBtn=='ytd'?'active':''" class="list-group-item list-group-item-action  px-3">
                YTD
              </button>
              <button type="button" (click)="getCampaignsLastMonth()" style="min-width: 110px;" [ngClass]="activeBtn=='month'?'active':''" class="list-group-item list-group-item-action  px-3">
                Last Month
              </button>
              <button type="button" (click)="getCampaignsLastYear()" style="min-width: 100px;" [ngClass]="activeBtn=='year'?'active':''" class="list-group-item list-group-item-action px-3">
               Last Year
              </button>
            </div>
          </div>
          <a type="button" 
                *ngIf="showSeeAll$ | async"
                class="subtitle-1--weight-regular ml-auto"
                style="
                cursor: pointer;
                color: #007bff;
                font-size: 12px;
                "
                (click)="onCampaignReportClick()">
            See All
          </a>
        </div>
        <div class="px-5 test position-relative"> 
          <div class="swiper" #swiper>
            <div class="swiper-wrapper py-4">
              <div  *ngFor="let campaign of campaigns"  class="swiper-slide justify-content-center" role="group">
                <img [src]='getCampaignImageUrl(campaign)' class="swiper-slide-card__image"/>
                <div class="swiper-slide-card__body">
                  <h5 class="subtitle-1--weight-regular mb-1 text-center">{{campaign.campaignData.name}}</h5>
                  <p class="subtitle-2--regular mb-0 cart-raised text-center">Paid: ${{getAmountDisplay(campaign.amount)}}</p>
                  <p class="subtitle-2--regular mb-0 cart-raised text-center">Pending: ${{getAmountDisplay(campaign.pending)}}</p>
                </div>
              </div>
            </div>
          </div>
          <div id="next" class="swiper-button-next swiper-button-next--pagination swiper-controls"></div>
          <div id='prev' class="swiper-button-prev swiper-button-prev--pagination swiper-controls"></div>
        </div>
      </div>


      <div *ngIf="!showSwiperContainer" class="mt-5 d-flex flex-column">
        <a type="button" 
            class="subtitle-1--weight-regular mr-auto"
            style="
            cursor: pointer;
            color: #007bff;
            font-size: 12px;
            "
            (click)="onCreateCampaignClick()">
             Create a New Campaign
        </a>
        <span *ngIf="!showSwiperContainer" style="font-size: 12px;color:#7c8187">
          You need to create campaigns to get started with dontaions or auctions.
        </span>
      </div>
